import { Component, input, computed } from '@angular/core';
import { TaskTypeWorkGroup, WorkPeriod } from '../Models/models';

@Component({
  selector: 'app-components-managecustomer-work-preview',
  templateUrl: './work-preview.component.html'
})
export class WorkPreviewComponent {
  previewPeriods = input<WorkPeriod[]>([]);
  periods = computed<WorkPeriod[]>(() => [...this.previewPeriods()]);
  lastPeriod = computed<number>(() => Math.max(...this.periods().map(period => period.period)));

  openedTaskGroups = new Set<TaskTypeWorkGroup>();

  toggleOpenCustomTaskGroup(group: TaskTypeWorkGroup): void {
    if (this.openedTaskGroups.has(group)) {
      this.openedTaskGroups.delete(group);
    } else {
      this.openedTaskGroups.add(group);
    }
  }
}
